<template>
    <el-dialog
      title="联系客服"
      :visible.sync="dialogVisible"
      width="400px">
      <div class="customer_service_box">
        <img class="customer_service_img" src="https://ai-ewg1990.oss-cn-guangzhou.aliyuncs.com/20250218/xianrui.jpg" alt="">
      </div>
      
    </el-dialog>
</template>

<script>
export default {
    data(){
        return {
            dialogVisible: false
        }
    },
    methods:{
        init(){
            this.dialogVisible = true;
        }
    }
}
</script>

<style lang="less" scoped>
    .customer_service_box{
        width: 100%;
        .customer_service_img{
            width: 100%;
        }
    }
</style>